import { createFileRoute } from "@tanstack/react-router";
import { EspaceScreen } from "@modules/applications/views";

// /applicant/home — the espace candidat, `applicant_workspace`'s `default_surface` landing. A
// returning founder who left mid-dossier lands here on login, not on a blank placeholder.
export const Route = createFileRoute("/applicant/home")({
  component: EspaceScreen,
});
